import React from 'react';
import createClass from 'create-react-class';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import {Form, InputWrapper, Button} from 'ui-library';
import {DebounceInput} from 'apps/shared/components';
import i18n from 'i18n';
import qs from 'query-string';

import {changePage, languageChange} from 'redux/modules/app';
import {loginRequest} from 'redux/modules/shared';

import AppActions from 'modules/legacy/js/actions/app';
import AuthActions from 'modules/legacy/js/actions/auth';
import emailRegex from 'modules/legacy/js/mixins/emailRegex';
import recaptcha from 'modules/legacy/js/mixins/recaptcha';
import passwordRegex from 'modules/legacy/js/mixins/passwordRegex';
import API from 'modules/legacy/js/lib/api';
import {LoginSupportLinks as SupportLinks} from 'modules/shared/containers';
import {PartnerFormRoute} from 'apps/advertisers/PartnerForm';


import { loginCoverImg, logoImgObs } from 'assets/images';

function mapStateToProps({app, shared}) {
  const {user, session} = shared;
  const {currentLanguage, partnerSettings} = app;
  return {user, session, currentLanguage, partnerSettings};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({changePage, loginRequest, languageChange}, dispatch);
}

const PasswordReset = createClass({
  displayName: 'ResetPasswordView',

  propTypes: {
    user: PropTypes.object,
    session: PropTypes.object,
    location: PropTypes.object,
    loginRequest: PropTypes.func,
    changePage: PropTypes.func,
    currentLanguage: PropTypes.string.isRequired
  },

  mixins: [
    emailRegex,
    recaptcha,
    passwordRegex,
    Reflux.listenTo(AuthActions.registerError, 'showError'),
    Reflux.listenTo(AppActions.reCAPTCHALoaded, 'updateReCaptchaWidget')
  ],

  getInitialState() {
    return {
      password: '',
      showPassword: false,
      confirmPassword: '',
      showConfirmPassword: false,
      errorMessage: ''
    };
  },

  componentDidMount() {
    const {user, location} = this.props;
    const query = qs.parse(location.search);

    if (!query.token) AuthActions.signout();
    if (user) this.loginUser();

    AppActions.hideLoader();
  },

  componentWillReceiveProps(props) {
    if (props.user) return this.loginUser(props);
    return null;
  },

  onSuccessfulPasswordRecovery() {
    AppActions.displayAlert({
      title: i18n.get('DEFAULT_SUCCESS_TITLE'),
      type: 'success',
      message: i18n.get('RESET_PASSWORD_PASSWORD_RESET_SUCCESS_ALERT_DESCRIPTION')
    });
  },

  onSendData(event) {
    const {loginRequest, location} = this.props;
    const query = qs.parse(location.search);

    event.preventDefault();
    if (!this.validateForm() && !!event) return event.stopPropagation();

    const params = {
      password: this.state.password,
      token: query.token
    };

    return API.setRecoverPassword(params, (err, res) => {
      const error = err ? res : null;
      if (error) return this.showError(error);

      loginRequest(res);
      return this.onSuccessfulPasswordRecovery();
    });
  },

  showError({message}) {
    AppActions.displayAlert({
      type: 'error',
      message
    });
    this.updateReCaptchaWidget();
  },

  loginUser(props = this.props) {
    const {session, user} = props;
    AuthActions.signinSuccess({
      user,
      token: session.token,
      account: user.account
    });
  },

  togglePassword() {
    const showPassword = !this.state.showPassword;
    const inputType = showPassword ? 'text' : 'password';

    this.setState({showPassword, passwordInputType: inputType});
  },

  validateForm() {
    let valid;
    let errorFocused;

    valid = true;
    errorFocused = false;
    const addErrorFn = (el) => {
      valid = false;
      el.parentNode.classList.add('error');

      if (errorFocused === false) {
        el.focus();
        errorFocused = true;
      }
    };

    if (!this.passwordRegex.test(this.state.password)) {
      addErrorFn(ReactDOM.findDOMNode(this.refs.passwordInput));
      this.setState({errorMessage: i18n.get('RESET_PASSWORD_INVALID_LENGTH')});
      return valid;
    }

    if (!this.passwordRegex.test(this.state.confirmPassword)) {
      addErrorFn(ReactDOM.findDOMNode(this.refs.confirmPasswordInput));
      this.setState({errorMessage: i18n.get('RESET_PASSWORD_INVALID_LENGTH')});
      return valid;
    }

    if (this.state.password !== this.state.confirmPassword) {
      addErrorFn(ReactDOM.findDOMNode(this.refs.passwordInput));
      addErrorFn(ReactDOM.findDOMNode(this.refs.confirmPasswordInput));
      this.setState({errorMessage: i18n.get('RESET_PASSWORD_PASSWORDS_MISMATCH')});
      return valid;
    }

    return valid;
  },

  handleStateInputChange(event, key) {
    event.target.parentNode.classList.remove('error');
    this.setState({
      [key]: event.target.value,
      errorMessage: ''
    });
  },

  render() {
    const {partnerSettings} = this.props;
    const {showPassword, showConfirmPassword} = this.state;

    if (partnerSettings) return <PartnerFormRoute />;

    return (
      <div className='vf-row no-space'>
        <div className='col-md-5 col-xs-12'>
          <div className='flex flex-row no-space start-md center-xs'>
            <div className='login'>
              <div className='background' />
              <div className='overlay' />

              <div className='form'>
                <div className='flex between-xs margin-vertical-1x'>
                  <img alt='' src={logoImgObs} className='logo' />
                  <Link
                    to='/login'
                    className='vf-btn outline vf-btn-primary vf-btn--sm'
                    style={{padding: '1.2rem 4rem', borderRadius: '2px'}}
                  >
                    {i18n.get('RESET_PASSWORD_LOG_IN')}
                  </Link>
                </div>

                <div className='title vf-text-gray-dark'>
                  {i18n.get('RESET_PASSWORD_RESET_YOUR_PASSWORD')}
                </div>

                <Form onSubmit={this.onSendData}>
                  <div className='vf-input-group'>
                    <InputWrapper ref='passwordWrapper' className='lg'>
                      <i className='vf-icon icon-locked'></i>
                      <DebounceInput
                        ref='passwordInput'
                        onChange={(e) => this.handleStateInputChange(e, 'password')}
                        className='login-input'
                        data-uitest='new-password'
                        placeholder={i18n.get('RESET_PASSWORD_CHOOSE_PASSWORD')}
                        type={showPassword ? 'text' : 'password'}
                        style={{paddingLeft: '6rem', fontSize: '2rem'}}
                        inputSize='lg'
                      />
                      <i
                        className={
                          `show-password ${
                            showPassword ? 'icon-eye-disabled' : 'icon-eye-1'
                          } show-password`
                        }
                        onClick={() => this.setState({showPassword: !showPassword})}
                      ></i>
                    </InputWrapper>

                    <InputWrapper ref='confirmPasswordWrapper' className='lg margin-top-2x'>
                      <i className='vf-icon icon-locked'></i>
                      <DebounceInput
                        ref='confirmPasswordInput'
                        onChange={(e) => this.handleStateInputChange(e, 'confirmPassword')}
                        className='login-input'
                        data-uitest='confirm-password'
                        placeholder={i18n.get('RESET_PASSWORD_CONFIRM_PASSWORD')}
                        type={showConfirmPassword ? 'text' : 'password'}
                        style={{paddingLeft: '6rem', fontSize: '2rem'}}
                        inputSize='lg'
                      />
                      <i
                        className={
                          `show-password ${
                            showConfirmPassword ? 'icon-eye-disabled' : 'icon-eye-1'
                          } show-password`
                        }
                        onClick={() => this.setState({showConfirmPassword: !showConfirmPassword})}
                      ></i>
                    </InputWrapper>

                    <InputWrapper hidden />
                  </div>

                  <div className='margin-top-2x'>
                    <span className='vf-text-danger'>
                      {this.state.errorMessage}
                    </span>
                  </div>

                  <div id='recaptcha' className='recaptcha-container' ref='recaptcha'></div>

                  <div className='center-xs'>
                    <Button
                      color='primary'
                      size='lg'
                      type='submit'
                      style={{borderRadius: '2px'}}
                    >
                      {i18n.get('RESET_PASSWORD_RESET_PASSWORD')}
                    </Button>
                  </div>
                </Form>
              </div>

              <SupportLinks />
            </div>
          </div>
        </div>

        <div className='col-md-7 hide-xs cover' style={{backgroundImage: `url('${loginCoverImg}')`}}>
          <div className='gradient login' />
        </div>
      </div>
    );
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(PasswordReset);
